import ItalicNode from './ItalicNode'
import ItalicButton from './ItalicButton'

const TYPE = 'Italic'
const TRIGGER_KEY = 'i'

const hasItalic = state => state.marks.count() && state.marks.some(mark => mark.type === TYPE)

const ItalicSchema = {
  marks: {
    Italic: ItalicNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .toggleMark(TYPE)
    .focus()
    .apply()
}

const ItalicPlugin = options => {
  return {
    schema: ItalicSchema,

    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasItalic,
  onClickButton,
  ItalicPlugin,
  ItalicSchema,
  ItalicNode,
  ItalicButton
}



// WEBPACK FOOTER //
// ./src/components/ItalicSlatePlugin/ItalicSlatePluginContainer.js